import { render, staticRenderFns } from "./ScheduleBadge.vue?vue&type=template&id=6e5b523e&scoped=true"
import script from "./ScheduleBadge.vue?vue&type=script&lang=js"
export * from "./ScheduleBadge.vue?vue&type=script&lang=js"
import style0 from "./ScheduleBadge.vue?vue&type=style&index=0&id=6e5b523e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5b523e",
  null
  
)

export default component.exports